import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import './styles.css';
import { signIn, signOut } from '../../../../common/auth/actions';
import { FilledButton } from '../';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import beta from './beta.png';

class Header extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false,
    };
  }

  handlePopoverClose = () => {
    this.setState({
      popoverOpen: false,
    });
  }

  handlePopoverOpen = (e) => {
    e.preventDefault();
    this.setState({
      popoverOpen: true,
      popoverAnchorEl: e.currentTarget,
    });
  }

  render() {
    const { title, from, viewer, disabled, signIn, signOut } = this.props;
    const { popoverOpen, popoverAnchorEl } = this.state;

    return (
      <div className="header">
        <Link
          className="link"
          to={{
            pathname: '/',
            state: { from },
          }}
          onClick={this.forceUpdate}
        >
          <div className="logo">
            <span className="icon-logo" />
            <h1>Húsfinnur</h1>
            <img src={beta} className="beta" role="presentation" />
          </div>
        </Link>
        <h2>{title}</h2>
        {!viewer ?
          <FilledButton
            content={
              <div>
                <span className="icon-facebook-icon" />
                <p>Skrá inn</p>
              </div>
            }
            disabled={disabled}
            color="#ffffff"
            backgroundColor="#3c5a99"
            onClick={() => signIn('facebook')}
          />
        :
          <div className="right-wrapper">
            <div className="create-property-button">
              <Link
                to={{
                  pathname: '/createProperty',
                  state: { from },
                }}
              >
                <FilledButton
                  content={
                    <div>
                      <span className="icon-new-property-icon" />
                      <p>Skráðu þína eign hér!</p>
                    </div>
                  }
                  color="#222222"
                  backgroundColor="#00e39a"
                />
              </Link>
            </div>
            <div className="user-info-wrapper">
              <img role="presentation" src={viewer ? viewer.photoURL : ''} width="32px" height="32px" />
              <button onClick={popoverOpen ? this.handlePopoverClose : this.handlePopoverOpen}>
                <span className="icon-burger hamburger" />
                <Popover
                  open={popoverOpen}
                  anchorEl={popoverAnchorEl}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                  onRequestClose={this.handlePopoverClose}
                  style={{ marginTop: '15px' }}
                >
                  <Menu>
                    <MenuItem primaryText="Allar eignir" onClick={() => this.context.router.transitionTo('/')} />
                    <MenuItem primaryText="Mínar eignir" onClick={() => this.context.router.transitionTo('/myProperties')} />
                    <MenuItem primaryText="Skrá út" onClick={signOut} />
                  </Menu>
                </Popover>
              </button>
            </div>
          </div>
        }
      </div>
    );
  }
}

Header.propTypes = {
  title: React.PropTypes.string.isRequired,
  from: React.PropTypes.string.isRequired,
  viewer: React.PropTypes.object,
  disabled: React.PropTypes.bool.isRequired,
  signIn: React.PropTypes.func.isRequired,
  signOut: React.PropTypes.func.isRequired,
};

export default connect(
  state => ({
    viewer: state.users.viewer,
    disabled: state.auth.formDisabled,
  }),
  { signIn, signOut },
)(Header);



// WEBPACK FOOTER //
// ./src/browser/app/components/Header/Header.js